<div [autofocus]="true" class="modal-body vtr-modal-export-log">
	<h1 id="hwscan-export-log-modal-title" class="title" role="heading">{{ 'hardwareScan.exportLog' | translate }}</h1>

	<div [ngSwitch]="errorStatus">
		<p *ngSwitchCase="enumExportLogErrorStatus.SuccessExport" id="hwscan-export-log-modal-description"
			class="description"
			role="text">{{ 'hardwareScan.exportLogModal.exportSuccessDescription' | translate }} {{ logPath }}</p>

		<p *ngSwitchCase="enumExportLogErrorStatus.AccessDenied" id="hwscan-export-log-modal-description"
			class="description" role="text">{{ 'hardwareScan.exportLogModal.exportAccessErrorDescription' | translate }}</p>


		<p *ngSwitchCase="enumExportLogErrorStatus.LoadingExport" id="hwscan-export-log-modal-description"
			class="description" role="text">{{ 'hardwareScan.exportLogModal.exportMayTakeSomeTime' | translate }}</p>

		<p *ngSwitchDefault id="hwscan-export-log-modal-description"
			class="description" role="text">{{ 'hardwareScan.exportLogModal.exportFailDescription' | translate }}</p>
	</div>

	<div [ngSwitch]="errorStatus" class="row button-row line-separator">

		<div class="col loading" *ngSwitchCase="enumExportLogErrorStatus.LoadingExport">
			<fa-icon role="img"
				[attr.aria-label]="'hardwareScan.exportLogModal.exportMayTakeSomeTime' | translate"
				placement="auto"
				[spin]="true"
				[icon]="['fal', 'circle-notch']"
				container="body">
			</fa-icon>
		</div>

		<vtr-material-button *ngSwitchCase="enumExportLogErrorStatus.AccessDenied"
			linkId="hwscan-export-log-open-settings-btn"
			[label]="'hardwareScan.exportLogModal.openSettingsButton' | translate | uppercase"
			[tooltipText] ="'hardwareScan.exportLogModal.openSettingsButton' | translate"
			(buttonClick)="openWindowsSettings()"
			heightSize="lg">
		</vtr-material-button>

		<vtr-material-button *ngSwitchDefault
			linkId="hwscan-export-log-confirm-btn"
			[label]="'hardwareScan.ok' | translate | uppercase"
			[tooltipText] ="'hardwareScan.ok' | translate"
			(buttonClick)="onClosing()"
			heightSize="lg">
		</vtr-material-button>
	</div>

	<div class="btn-modal-close" *ngIf="errorStatus !== enumExportLogErrorStatus.LoadingExport">
		<vtr-ui-close-button linkId="hwscan-export-log-modal-close-btn"
			(clickClose)="onClosing()">
		</vtr-ui-close-button>
	</div>
</div>
